import { render, staticRenderFns } from "./UniversityGender.vue?vue&type=template&id=b99b12ba&scoped=true&"
import script from "./UniversityGender.vue?vue&type=script&lang=js&"
export * from "./UniversityGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99b12ba",
  null
  
)

export default component.exports